import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Autocomplete, OutlinedInput } from "@mui/material";
import { forwardRef } from "react";
import { MetadataInputProps } from "../metadata-input-index";

const MetadataInputLangMulti = forwardRef<any, MetadataInputProps>((props, ref) => {
  const { onChange, data, value, predefinedValues } = props;
  const values =
    data.values
      ?.filter((v) => v.valueObject !== null && v.valueObject?.value !== null)
      .flatMap((v) => v.valueObject?.value) || [];
  return (
    <Autocomplete
      id={data.tagName!}
      // options management
      options={values}
      disableClearable={predefinedValues}
      getOptionLabel={(option: any) => option.value! + (option.label ? " (" + option.label + ")" : "")}
      isOptionEqualToValue={(option, value) => option.value === value?.value || value === ""}
      // value management
      value={value ? value.value : []}
      onChange={(e, value) => {
        onChange(value !== null && value.length > 0 ? value : [], data.id);
      }}
      // render input
      multiple
      popupIcon={<ExpandMoreRoundedIcon />}
      renderInput={(params) => (
        <OutlinedInput {...params.InputProps} inputProps={params.inputProps} required sx={{ width: "100%" }} />
      )}
      sx={{ width: "100%" }}
    />
  );
});

export default MetadataInputLangMulti;
